import cssVars from "css-vars-ponyfill";

export default {
	init() {
		// initialise css-vars-ponyfill only if needed
		if (!window.CSS || !window.CSS.supports || !window.CSS.supports("(--a: 0)"))
			cssVars();
	}
};
